'use client'

import { useState } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { motion, AnimatePresence } from 'framer-motion'
import HeaderGap from '@/components/atoms/headerGap'

const FACILITIES_SUB = [
  { name: 'Padel',      link: '/padel-ubud'  },
  { name: 'Tennis',     link: '/tennis-ubud' },
  { name: 'Gym',        link: '/gym-ubud'    },
  { name: 'Restaurant', link: '/restaurant'  },
]

const CAMPS_SUB = [
  { name: 'Tennis Camp', link: '/tennis-camp' },
  { name: 'Padel Camp',  link: '/padel-camp'  },
]

const mainCls = (active) =>
  `font-ttDrugsTrial uppercase leading-none transition-colors duration-300 text-[28px] md:text-[44px] ${
    active ? 'text-olive' : 'text-khaki hover:text-olive'
  }`

const subCls = (active) =>
  `font-ttDrugsTrial uppercase leading-none transition-colors duration-300 text-[20px] md:text-[28px] ${
    active ? 'text-olive' : 'text-khaki hover:text-olive'
  }`

// Main item with an expandable list of sub-pages (Facilities, Camps)
const DropdownGroup = ({ label, items, active, onClose }) => {
  const pathname = usePathname()
  const [open, setOpen] = useState(false)
  return (
    <div className="flex flex-col">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`${mainCls(active)} flex items-baseline gap-4 text-left`}
      >
        {label}
        <span className="text-[22px] md:text-[30px] leading-none font-ttDrugsTrial">
          {open ? '−' : '+'}
        </span>
      </button>

      <motion.div
        initial={false}
        animate={{ height: open ? 'auto' : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.25, ease: 'easeInOut' }}
        className="overflow-hidden"
      >
        <div className="flex flex-col gap-y-[14px] lg:gap-y-[18px] mt-[16px] pl-[28px] lg:pl-[48px] border-l border-khaki/40">
          {items.map((item) => (
            <Link
              key={item.link}
              href={item.link}
              scroll={false}
              className={subCls(pathname === item.link)}
              onClick={onClose}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </motion.div>
    </div>
  )
}

const MenuItem = ({ onClose, hideEventsPage }) => {
  const pathname = usePathname()

  const isFacilitiesActive =
    pathname === '/facilities' || FACILITIES_SUB.some((i) => i.link === pathname)

  return (
    <div className="relative w-full grow overflow-y-scroll scrollbar-hidden px-smallMobile md:px-mediumDesktop">
      <HeaderGap />
      <nav className="flex flex-col gap-y-[22px] lg:gap-y-[28px] mt-[80px] mb-[80px]">

        <DropdownGroup
          label="FACILITIES"
          items={FACILITIES_SUB}
          active={isFacilitiesActive}
          onClose={onClose}
        />

        <Link scroll={false} href="/pricing" className={mainCls(pathname === '/pricing')} onClick={onClose}>
          PRICING
        </Link>

        <Link scroll={false} href="/retreat" className={mainCls(pathname === '/retreat')} onClick={onClose}>
          RETREAT
        </Link>

        <DropdownGroup
          label="CAMPS"
          items={CAMPS_SUB}
          active={CAMPS_SUB.some((i) => i.link === pathname)}
          onClose={onClose}
        />

        <Link scroll={false} href="/schedule-and-classes" className={mainCls(pathname === '/schedule-and-classes')} onClick={onClose}>
          SCHEDULE &amp; CLASSES
        </Link>

        <Link scroll={false} href="/about" className={mainCls(pathname === '/about')} onClick={onClose}>
          ABOUT US
        </Link>

        <Link scroll={false} href="/contact" className={mainCls(pathname === '/contact')} onClick={onClose}>
          CONTACT
        </Link>

        <a
          href="https://open.mahimabali.com"
          target="_blank"
          rel="noopener noreferrer"
          className={mainCls(false)}
        >
          MAHIMA OPEN 2026
        </a>
      </nav>
    </div>
  )
}

export default MenuItem
